// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RecordPrompt_wrapper__wVDXW","nameInput":"RecordPrompt_nameInput__2tLwb","submitButton":"RecordPrompt_submitButton__jHO8C"};